<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('adminProduct.queryCondition') }}</span>
          </div>
          <div class="">
            <el-form :inline="true" :model="adminProductInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="adminProductInfo.conditions.prodNameLike"
                  :placeholder="$t('adminProduct.inputProductName')" class="filter-item"></el-input>
              </el-form-item>
              <el-form-item>
                <el-select v-model="adminProductInfo.conditions.auditState" placeholder="审核状态" clearable>
                  <el-option label="待审核" value="1001"></el-option>
                  <el-option label="审核通过" value="2002"></el-option>
                  <el-option label="审核失败" value="3003"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input v-model="adminProductInfo.conditions.importLogId" placeholder="批次号" class="filter-item"
                  clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryProductMethod()">{{ $t('adminProduct.query')
                  }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="success" size="small" :disabled="selectedProducts.length === 0"
                  @click="_batchAudit('2002')">批量通过</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="warning" size="small" :disabled="selectedProducts.length === 0"
                  @click="_batchAudit('3003')">批量驳回</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('adminProduct.onShelfProducts') }}</span>
          </div>
          <el-table :data="adminProductInfo.products" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45" align="center"></el-table-column>
            <el-table-column prop="productId" :label="$t('adminProduct.productId')" align="center"></el-table-column>
            <el-table-column prop="importLogId" label="批次号" align="center" width="160">
              <template slot-scope="scope">
                {{ scope.row.importLogId || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('adminProduct.productImage')" align="center">
              <template slot-scope="scope">
                <img :src="scope.row.coverPhoto" style="width: 60px; height: 60px; border-radius: 5px;" />
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" :label="$t('adminProduct.productGroup')"
              align="center"></el-table-column>
            <el-table-column prop="prodName" :label="$t('adminProduct.productName')" align="center"></el-table-column>
            <el-table-column prop="sales" :label="$t('adminProduct.sales')" align="center"></el-table-column>
            <el-table-column prop="stock" :label="$t('adminProduct.stock')" align="center"></el-table-column>
            <el-table-column prop="defaultSpecValue.price" :label="$t('adminProduct.price')"
              align="center"></el-table-column>
            <el-table-column prop="stateName" :label="$t('adminProduct.status')" align="center"></el-table-column>
            <el-table-column prop="auditStateName" label="审核状态" align="center"></el-table-column>
            <el-table-column prop="auditOpinion" label="审核意见" align="center"></el-table-column>
            <el-table-column prop="createTime" :label="$t('adminProduct.shelfTime')" align="center"></el-table-column>
            <el-table-column :label="$t('adminProduct.operation')" align="center" width="320">
              <template slot-scope="scope">
                <div class="operation-actions">
                  <div class="operation-row">
                    <el-button size="mini" @click="_viewProductDetail(scope.row)">查看详情</el-button>
                    <el-button size="mini" @click="_viewProductQrcode(scope.row)">二维码</el-button>
                    <el-button size="mini" type="danger" @click="_openDeleteProductModel(scope.row)">{{
                      $t('adminProduct.delete') }}</el-button>
                  </div>
                  <div v-if="scope.row.auditState === '1001'" class="operation-row">
                    <el-button size="mini" type="success" @click="_auditProduct(scope.row, '2002')">通过</el-button>
                    <el-button size="mini" type="warning" @click="_auditProduct(scope.row, '3003')">驳回</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, jumper" :total="total" class="pagination"></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <delete-product ref="deleteProduct"></delete-product>
    <view-qrcode ref="qrcodeDialog" />

  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryAdminProduct, auditProduct } from '@/api/goods/adminProductApi'
import { batchAuditProduct } from '@/api/goods/importBatchApi'
import AdminShop from '@/components/shop/adminShop'
import DeleteProduct from '@/components/admin/deleteProduct/deleteProduct'
import ViewQrcode from '@/components/system/viewQrcode.vue'


export default {
  name: 'AdminProduct',
  components: {
    AdminShop,
    DeleteProduct,
    ViewQrcode

  },
  data() {
    return {
      shopId: '',
      adminProductInfo: {
        products: [],
        total: 0,
        records: 1,
        moreCondition: false,
        productId: '',
        conditions: {
          categoryId: '',
          state: '',
          auditState: '',
          // 模糊匹配参数：prodName 为全名精确匹配（Mapper t.prod_name=），查询框传 prodNameLike（LIKE %..%）
          prodNameLike: '',
          // 只查未删除商品：Mapper 无默认 status_cd 过滤，软删除商品会被查出
          statusCd: '0',
          keyword: '',
          barCode: '',
          shopId: '',
          // 商品导入批次号筛选（导入管理页跳转带入）
          importLogId: ''
        },
        productCategorys: []
      },
      selectedProducts: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    // 只取 shopId（查询依赖该上下文），查询动作统一推迟到 mounted，避免首屏重复请求闪变
    this.shopId = getShopId()
  },
  mounted() {
    // 导入管理页「去审核」跳转带入批次号，自动筛选；首屏查询统一在 mounted 发起
    // 同时默认只看待审核商品：批量通过后刷新即被过滤出列表（否则会看到已审核项仍滞留，
    // 误以为未刷新）；下拉可手动清空查看该批次全部商品
    const importLogId = this.$route.query.importLogId
    if (importLogId) {
      this.adminProductInfo.conditions.importLogId = String(importLogId)
      this.adminProductInfo.conditions.auditState = '1001'
    }
    this._listAdminProducts(1, 10)
  },
  methods: {
    handleShopChange(shop) {
      this.adminProductInfo.conditions.shopId = shop.shopId
      this._listAdminProducts(1, 10)
    },
    async _listAdminProducts(page, rows) {
      this.adminProductInfo.conditions.page = page
      this.adminProductInfo.conditions.row = rows
      try {
        const res = await queryAdminProduct(this.adminProductInfo.conditions)
        this.adminProductInfo.total = res.total
        this.adminProductInfo.records = res.records
        this.adminProductInfo.products = res.data
        // 分页 total 绑定真实总记录数；res.records 为总页数（ResultVo 契约：records=页数,total=总数），勿混用
        this.total = res.total
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openDeleteProductModel(product) {
      this.$refs.deleteProduct.open(product)
    },
    _queryProductMethod() {
      this._listAdminProducts(1, 10)
    },
    async _auditProduct(product, auditState) {
      const actionText = auditState === '2002' ? '审核通过' : '审核驳回'
      try {
        const { value } = await this.$prompt('请输入审核意见', actionText, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: auditState === '2002' ? '审核通过' : ''
        })
        const res = await auditProduct({
          productId: product.productId,
          shopId: product.shopId,
          auditState,
          auditOpinion: value
        })
        if (res.code === 0) {
          this.$message.success(actionText)
          this._refreshAfterAudit(1)
        } else {
          this.$message.error(res.msg || '审核失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('审核商品失败:', error)
          this.$message.error('审核失败')
        }
      }
    },
    /**
     * 审核成功后刷新：先按"旧总数-已审核数"估算新总数，
     * 当前页被审空时自动回退到最后一页有数据的页，避免停留在空页
     */
    _refreshAfterAudit(auditedCount) {
      const newTotal = Math.max(0, this.total - auditedCount)
      const maxPage = Math.max(1, Math.ceil(newTotal / this.pageSize))
      const target = Math.min(this.currentPage, maxPage)
      this.selectedProducts = []
      this._listAdminProducts(target, this.pageSize)
      // 通知 layout 立即刷新审核待办角标，不等 60s 轮询
      window.dispatchEvent(new Event('mall-audit-todo-changed'))
    },
    handleSelectionChange(selection) {
      this.selectedProducts = selection || []
    },
    async _batchAudit(auditState) {
      const selected = this.selectedProducts
      if (!selected || selected.length === 0) {
        this.$message.warning('请先勾选商品')
        return
      }
      if (selected.length > 5000) {
        this.$message.warning('单次批量审核不能超过 5000 件，请分批操作')
        return
      }
      const actionText = auditState === '2002' ? '批量通过' : '批量驳回'
      try {
        const { value } = await this.$prompt('请输入审核意见', actionText + '（共 ' + selected.length + ' 件）', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: auditState === '2002' ? '审核通过' : ''
        })
        const res = await batchAuditProduct({
          productIds: selected.map(item => item.productId),
          auditState,
          auditOpinion: value
        })
        if (res.code === 0) {
          this.$message.success(actionText + '成功')
          this._refreshAfterAudit(selected.length)
        } else {
          this.$message.error(res.msg || actionText + '失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error(actionText + '失败:', error)
          this.$message.error(actionText + '失败')
        }
      }
    },
    _viewProductDetail(product) {
      const route = this.$router.resolve({
        path: '/pages/goods/productDetail',
        query: {
          productId: product.productId,
          shopId: product.shopId,
          adminView: 'Y'
        }
      })
      window.open(route.href, '_blank')
    },
    _viewProductQrcode(product) {
      const qrcodeData = {
        qrcodeName: product.prodName,
        qrCodeUrl:  product.pageUrl,
        remark: '手机扫码查看商品'
      }
      this.$refs.qrcodeDialog.open(qrcodeData)
    },
    handleCurrentChange(val) {
      this._listAdminProducts(val, 10)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.filter-container {
  padding-bottom: 10px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.operation-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.operation-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
}

.operation-row ::v-deep .el-button {
  margin-left: 0;
}
</style>
